export enum CHANNEL_TYPE_ENUM {
  ACCOUNT_TRANSFER = 'ACCOUNT_TRANSFER',
}
